import { createTheme } from "@mui/material";
//
import palette from "./palette";
import componentsOverrides from "./overrides";

const theme = createTheme({
  typography: {
    fontFamily: 'Public Sans, sans-serif',
  },
  palette: palette.dark
});

theme.components = componentsOverrides(theme);

export default theme;